import React, { Fragment } from 'react';
import { ActionTableBodyItem, TableBodyItem } from '../../Table.styles';
import { ReactComponent as EditIcon } from '../../../../assets/icons/edit-01.svg';

const OrganizationMemberItem = ({ name, role, email }) => {
  return (
    <Fragment>
      <TableBodyItem>
        <p>{name || '-'}</p>
      </TableBodyItem>
      <TableBodyItem>
        <p>{email || '-'}</p>
      </TableBodyItem>
      <TableBodyItem>
        <p>{role || '-'}</p>
      </TableBodyItem>
      <ActionTableBodyItem>
        <EditIcon />
      </ActionTableBodyItem>
    </Fragment>
  );
};

export default OrganizationMemberItem;
